var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "open-on-hover": !_vm.display_icon,
        "offset-y": "",
        "open-delay": 1000
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _vm.display_icon
                ? _c(
                    "v-icon",
                    _vm._g({ attrs: { color: "background lighten-4" } }, on),
                    [_vm._v("\n\t\t\t" + _vm._s(_vm.display_icon) + "\n\t\t")]
                  )
                : _c(
                    "v-chip",
                    _vm._g(
                      {
                        class: { "not-found": _vm.state === "not_found" },
                        attrs: {
                          label: "",
                          small: "",
                          close: _vm.state !== "loading"
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("remove")
                          }
                        }
                      },
                      on
                    ),
                    [
                      _vm.state === "found"
                        ? _c("span", [_vm._v(_vm._s(_vm.chip_label))])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state === "not_found"
                        ? _c("span", [
                            _vm._v(
                              "\n\t\t\t\t" + _vm._s(_vm.asset_id) + "\n\t\t\t"
                            )
                          ])
                        : _vm.state === "loading"
                        ? _c(
                            "span",
                            [
                              _vm._v(
                                "\n\t\t\t\t" +
                                  _vm._s(_vm.asset_id) +
                                  "\n\t\t\t\t"
                              ),
                              _c("v-progress-circular", {
                                staticClass: "ml-2",
                                attrs: {
                                  indeterminate: "",
                                  size: 18,
                                  width: 2,
                                  color: "background lighten-5"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "background" },
        [
          _vm.state === "found"
            ? _c(
                "v-card-title",
                { staticClass: "pt-2 pb-0 subheading" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: _vm.asset_url, target: "_blank" } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.asset.id) + "\n\t\t\t\t"
                      ),
                      _c("span", { staticClass: "mx-1" }, [_vm._v("|")]),
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.asset.ref_material) +
                          "\n\t\t\t\t"
                      ),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-bottom": "2px" },
                          attrs: { small: "" }
                        },
                        [_vm._v("open_in_new")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-text",
            { class: { "text-center": _vm.state !== "found" } },
            [
              _vm.state === "loading"
                ? _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: 32,
                      width: 2,
                      color: "background lighten-5"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.state === "not_found"
                ? _c("span", { staticClass: "orange--text text--lighten-2" }, [
                    _vm._v("\n\t\t\t\tAsset introuvable\n\t\t\t")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.state === "found"
                ? _c("table", [
                    _c("tr", [
                      _c("th", [_vm._v("Titre")]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          { attrs: { href: _vm.title_url, target: "_blank" } },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.title_name) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("open_in_new")
                            ])
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Titre alt")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.title_alternative))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Programme")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.program_lib_type_prgm))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Version")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.program_version))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Observation")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.asset.observation || "-"))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Duration")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.asset.duration || "-"))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Poids")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("humanizeBytes1000")(_vm.asset.asset_size)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Prorio")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.t_aux_name))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Type")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.type_sup))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Norme")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.asset.norm || "-"))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Proxy")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.asset.has_proxy
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "green accent-2" }
                                },
                                [_vm._v("\n\t\t\t\t\t\t\tdone\n\t\t\t\t\t\t")]
                              )
                            : _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "error accent-2" }
                                },
                                [_vm._v("\n\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t")]
                              )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Verif")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.asset.has_rv
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "green accent-2" }
                                },
                                [_vm._v("\n\t\t\t\t\t\t\tdone\n\t\t\t\t\t\t")]
                              )
                            : _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "error accent-2" }
                                },
                                [_vm._v("\n\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t")]
                              ),
                          _vm._v(" "),
                          _vm.asset.has_rv
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "my-0",
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    flat: "",
                                    href: _vm.asset_url + "rv/",
                                    target: "_blank"
                                  }
                                },
                                [_c("v-icon", [_vm._v("open_in_new")])],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("BeHive categorie")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.asset.behive_category))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Vidéo")]),
                      _vm._v(" "),
                      _vm.resume_detail_video.length
                        ? _c(
                            "td",
                            _vm._l(_vm.resume_detail_video, function(item, i) {
                              return _c(
                                "v-chip",
                                {
                                  key: "video_" + i,
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "background lighten-2"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _c("td", [_vm._v("-")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Audio")]),
                      _vm._v(" "),
                      _vm.resume_detail_audio.length
                        ? _c(
                            "td",
                            _vm._l(_vm.resume_detail_audio, function(item, i) {
                              return _c(
                                "v-chip",
                                {
                                  key: "audio_" + i,
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "background lighten-2"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _c("td", [_vm._v("-")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", [_vm._v("Sous-titres")]),
                      _vm._v(" "),
                      _vm.resume_detail_subtitle.length
                        ? _c(
                            "td",
                            _vm._l(_vm.resume_detail_subtitle, function(
                              item,
                              i
                            ) {
                              return _c(
                                "v-chip",
                                {
                                  key: "subtitle_" + i,
                                  attrs: {
                                    label: "",
                                    small: "",
                                    color: "background lighten-2"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _c("td", [_vm._v("-")])
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10cd1e6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10cd1e6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/asset_chip.vue
// module id = null
// module chunks = 